import React, { useMemo } from "react";
import { Popover, Table, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import dayjs from "dayjs";

const CertificationTable = ({ companyData }) => {
  const navigate = useNavigate();

  // ✅ Sort invoices by invoiceNo
 const invoices = useMemo(() => {
  if (!companyData?.invoices) return [];

  return [...companyData.invoices].sort((a, b) =>
    b.invoiceNo.localeCompare(a.invoiceNo)
  );
}, [companyData]);

  const columns = [
    {
      title: "Invoice No",
      dataIndex: "invoiceNo",
      render: (val) => <b>{val}</b>,
    },
    {
      title: "Agent Name",
      dataIndex: "agentName",
    },
    {
      title: "Total Closure",
      dataIndex: "baseClosureAmount",
      key: "baseClosureAmount",
      render: (val, record) =>
        `${record.currency} ${(val || 0).toLocaleString()}`,
    },
    {
      title: "Term Amount",
      dataIndex: "termsBaseAmmount",
      render: (val,record) => `${record.currency} ${val?.toLocaleString()}`,
    },
    {
      title: "Pending Payment",
      dataIndex: "pendingPayment",
      render: (val,record) => (
        <span style={{ color: val > 0 ? "red" : "green" }}>
          {record.currency} {val?.toLocaleString()}
        </span>
      ),
    },
    {
      title: "Status",
      render: (_, record) => (
        <Tag color={record.paymentStatus > 0 ? "red" : "green"}>
          {record.paymentStatus}
        </Tag>
      ),
    },
     {
          title: "Invoice Date",
          dataIndex: "invoiceDate",
          key: "createdAt",
          render: (val) => dayjs(val).format("DD MMM YYYY"),
        },
    {
      title:"Action",
      render: (_, record) => (
        <Popover content="View Invoice">
              <AiOutlineEye
                size={18}
                style={{ cursor: "pointer", color: "#1890ff" }}
                onClick={() => navigate(`/view-invoice-page/${record._id}`)}
              />
            </Popover>
      )

    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={invoices.map((item) => ({
        ...item,
        key: item._id,
      }))}
      pagination={{ pageSize: 10 }}
      onRow={(record) => ({
        onClick: () =>
          navigate(`/view-invoice-page/${record._id}`),
      })}
    />
  );
};

export default CertificationTable;